import { Component } from '@theme/component';

/**
 * A carousel that shows one recommended product at a time with prev/next
 * navigation. Cards are plain server-rendered markup, so the theme's
 * section-rendering morph safely preserves this component across cart
 * updates (see `updatedCallback` on the base `Component` class).
 */
class CartCrossSellComponent extends Component {
  requiredRefs = ['viewport'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.viewport.addEventListener('scroll', this.#updateArrowState);
    this.#updateArrowState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.viewport.removeEventListener('scroll', this.#updateArrowState);
  }

  handlePrev() {
    this.#goTo(this.#currentIndex() - 1);
  }

  handleNext() {
    this.#goTo(this.#currentIndex() + 1);
  }

  #getCards() {
    return Array.from(this.refs.viewport.querySelectorAll('.cart-cross-sell__card'));
  }

  #currentIndex() {
    const viewport = this.refs.viewport;
    const cards = this.#getCards();
    const containerRect = viewport.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;
    let closest = 0;
    let closestDist = Infinity;

    cards.forEach((card, i) => {
      const r = card.getBoundingClientRect();
      const cardCenter = r.left + r.width / 2;
      const dist = Math.abs(cardCenter - containerCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });

    return closest;
  }

  #goTo(index) {
    const viewport = this.refs.viewport;
    const cards = this.#getCards();
    if (!cards.length) return;

    const clamped = Math.max(0, Math.min(index, cards.length - 1));
    const target = cards[clamped];
    if (!target) return;

    const containerRect = viewport.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const delta = targetRect.left + targetRect.width / 2 - (containerRect.left + containerRect.width / 2);

    viewport.scrollBy({ left: delta, behavior: 'smooth' });
  }

  #updateArrowState = () => {
    const cards = this.#getCards();
    const index = this.#currentIndex();
    const prevButton = this.refs.prevButton;
    const nextButton = this.refs.nextButton;

    if (prevButton) prevButton.disabled = index <= 0;
    if (nextButton) nextButton.disabled = index >= cards.length - 1;
  };
}

if (!customElements.get('cart-cross-sell-component')) {
  customElements.define('cart-cross-sell-component', CartCrossSellComponent);
}
